import type { CSSProperties } from "react";

export const glassPanel: CSSProperties = {
  background: "#ffffff",
  border: "1px solid rgba(0, 0, 0, 0.08)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.08)",
};

export const glassPanelDense: CSSProperties = {
  background: "#ffffff",
  border: "1px solid rgba(0, 0, 0, 0.10)",
  boxShadow: "0 4px 16px rgba(0, 0, 0, 0.10)",
};

export const glassPanelLight: CSSProperties = {
  background: "#f8f9fa",
  border: "1px solid rgba(0, 0, 0, 0.06)",
  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.06)",
};
